import type { MemberDto } from '../api/types';

/** Пороги id своих сообщений, до которых они доставлены/прочитаны всеми собеседниками. */
export interface ReceiptThresholds {
  delivered: number;
  read: number;
}

/**
 * Восстанавливает галки после перезагрузки из маркеров участников (`GET /chats/{id}/members`).
 * Правило как у realtime-событий: «доставлено» — хватает одного получателя; «прочитано» — прочли
 * все, кто не скрывает статусы (скрытые не учитываются). Если свои статусы выключены, прочтение
 * чужих не показываем вовсе (сервер и так отдаёт им null, но порог не должен синеть).
 */
export function receiptThresholds(
  members: MemberDto[],
  meId: string,
  myReceiptsEnabled: boolean,
  roomId?: string | null,
): ReceiptThresholds {
  const others = members.filter((m) => m.user.id !== meId);
  const readMarker = (member: MemberDto) => member.roomMarkers === undefined
    ? member.lastReadMessageId ?? 0
    : member.roomMarkers.find((marker) => marker.roomId === (roomId ?? null))?.lastReadMessageId ?? 0;
  const deliveredMarker = (member: MemberDto) => member.roomMarkers === undefined
    ? member.lastDeliveredMessageId ?? 0
    : member.roomMarkers.find((marker) => marker.roomId === (roomId ?? null))?.lastDeliveredMessageId ?? 0;
  let delivered = 0;
  for (const m of others) delivered = Math.max(delivered, deliveredMarker(m), readMarker(m));
  let read = 0;
  if (myReceiptsEnabled) {
    const visible = others.filter((m) => !m.user.readReceiptsDisabled);
    if (visible.length > 0) read = Math.min(...visible.map(readMarker));
  }
  return { delivered: Math.max(delivered, read), read };
}
